import React, { useEffect, useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import InvoiceTypeForm from '../../../components/forms/InvoiceTypeForm';
import { useInvoiceTypeApi } from '../../../hooks/useInvoiceTypeApi';
import { useNavigate, useParams } from 'react-router-dom';
import { InvoiceTypeDTO } from '../../../services/apiClient';

const InvoiceTypeEdit: React.FC = () => {
  const { getById, edit } = useInvoiceTypeApi();
  const [entityData, setEntityData] = useState<InvoiceTypeDTO | null>(null);
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Invoice Types', href: '/admin/invoicetypes' },
    { label: 'Edit', href: '#' },
  ];

  useEffect(() => {
    const fetchEntityData = async () => {
      try {
        const response = await getById(id!);
        setEntityData(response?.data || null);
      } catch (error) {
        console.error('Error fetching InvoiceType data:', error);
      }
    };

    fetchEntityData();
  }, [id]);

  const handleSubmit = async (data: any) => {
    try {
      setIsSubmitting(true);
      await edit(id!, data);
      navigate('/admin/invoicetypes');
    } catch (error) {
      console.error('Error updating InvoiceType:', error);
    } finally{
      setIsSubmitting(false);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/invoicetypes"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission='Settings.InvoiceType.Edit'
    >
        {entityData ? (
          <InvoiceTypeForm
            initialValues={entityData}
            onSubmit={handleSubmit}
            onCancel={() => navigate('/admin/invoicetypes')}
            isLoading={isSubmitting}
          />
        ) : (
          <p>Loading...</p>
        )}
    </AdminLayout>
  );
};

export default InvoiceTypeEdit;